import { api } from '@services';

import qs from 'query-string';

import Manufacturer, {
  IManufacturerCreateUpdate,
  IManufacturerCreateUpdateApiModel,
} from '@models/Manufacturer.model';
import { IPaginationResult } from '@models/Equipment.model';

interface IRequest {
  search: string;
  limit: number;
  page: number;
}

const getManufacturersCreateUpdate = async ({
  limit = 20,
  page,
  search,
}: IRequest): Promise<IPaginationResult<IManufacturerCreateUpdate>> => {
  const query = {
    limit,
    page,
    q: search,
  };

  const queryString = qs.stringify(query);
  const { data: manufacturers } = await api.get<
    IPaginationResult<IManufacturerCreateUpdateApiModel>
  >(`/manufacturers/createUpdate?${queryString}`);

  return Manufacturer.arrayPaginatedFromCreateUpdateApiModel(manufacturers);
};

export { getManufacturersCreateUpdate };
